import { h } from '@stencil/core';
export class Usc {
  render() {
    return (h("div", { class: "usc-wrapper" }, h("slot", null)));
  }
  static get is() { return "pes-usc"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["usc.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["usc.css"]
    };
  }
}
